import React, { useState, useEffect } from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pinput() {

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }


  
  return (
    <div>
      <Sides />
      <Helmet>

        <title>Learn Free Python Input Beginners Tutorials CodeExampler</title>
        <meta name="description" content="Python Input tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like Python tutorial, Python tutorial,Python tutorial for beginners in deeply knowledge With Deeply" />
        <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,Input in python,User input in python,python input,python input from user,python input user,python input function,python input integer,python input string,python input keyboard,python input command line,python input from command line,python input list,python input arguments,python input float,python input output,python input command,python input split,python input number,python raw_input vs input,python input text,python input and output,python input example
 " />
        <link rel="canonical" href="https://www.codeexampler.com/python-input" />
      </Helmet>

      <div className='lg:pl-56'>

        <h1 className="m-4 mh1">Python input from User or User input in Python</h1>

        <div className="first">
          <a href="/python-keywords">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a>
          <a href="/python-comments">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a>
        </div>


        <h2 className="mt-4">Python input uses to input a value By the user.
        </h2>




        <h2 className='headings mt-3'>Syntax of User input in Python:</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-4">x</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty-10">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">()</span>
              <span className="qwerty-10">)</span>
              {"\n"}{"\n"}
            </code>
          </pre>
        </div>


        <h2 className="mt-4 mh2">Example of User input in python:</h2>






        <h2 className='headings'>Q-User input a no in Python and after Print this no?</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-4">a</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-10">Enter a No</span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">You Entered:</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty">+</span>
              <span className="qwerty-4">a</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>
        <h5 className='headings'> Output : </h5>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "100vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-10">Enter a No </span>
              <span className="qwerty-7">48</span>
              {"\n"}
              <span className="qwerty-10">You Entered: </span>
              <span className="qwerty-3">48</span>
              {"\n"}      {"\n"}
            </code>
          </pre>
        </div>


      

    

        <h2 className='headings'>Q-Write a program to input Three numbers in python and Addition and print the total marks?</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter First no:</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">a</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-10">Enter a No </span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter Second no:</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">b</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-10">Enter a No</span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter Third no:</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">c</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-10">Enter a No</span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-7">sum</span>
              <span className="qwerty-1">=</span>
              <span className="qwerty-4">a</span>
              <span className="qwerty">+</span>
              <span className="qwerty-4">b</span>
              <span className="qwerty">+</span>
              <span className="qwerty-4">c;</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
            
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Sum :</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty">,</span>
              <span className="qwerty-4">sum</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>
        <h5 className='headings'> Output : </h5>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "100vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-10">Enter First no: </span>
              {"\n"}
              <span className="qwerty-1">Enter a No</span>
              <span className="qwerty-3"> 4</span>
              {"\n"}
              <span className="qwerty-10">Enter Second no: </span>
              {"\n"}
              <span className="qwerty-1">Enter a No</span>
              <span className="qwerty-3"> 5</span>
              {"\n"}
              <span className="qwerty-10">Enter Third no: </span>
              {"\n"}
              <span className="qwerty-1">Enter a No</span>
              <span className="qwerty-3"> 4</span>
              {"\n"}
              <span className="qwerty-8">Sum</span>
              <span className="qwerty-6"> 454</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>


        <h2 className="mt-4 mh2">Example of Simple Intreast in python:</h2>




        <h2 className='headings'>Q-Write a program to calculate and print simple interest and user input in python?</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter value of </span>
              <span className="qwerty">P</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">a</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty">int</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter value of </span>
              <span className="qwerty">R</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">b</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty">int</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter value of </span>
              <span className="qwerty">T</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">c</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty">int</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-7">si</span>
              <span className="qwerty-1">=</span>
              <span className="qwerty-4">a</span>
              <span className="qwerty">*</span>
              <span className="qwerty-4">b</span>
              <span className="qwerty">*</span>
              <span className="qwerty-4">c;</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Simple Interest:</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty">,</span>
              <span className="qwerty-4">si</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>
        <h5 className='headings'> Output : </h5>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "100vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-10">Enter value of</span>
              <span className="qwerty-8"> P </span>
              {"\n"}
              <span className="qwerty-3"> 2</span>
              {"\n"}
              <span className="qwerty-10">Enter value of</span>
              <span className="qwerty-8"> R </span>
              {"\n"}
              <span className="qwerty-3"> 4</span>
              {"\n"}
              <span className="qwerty-10">Enter value of</span>
              <span className="qwerty-8"> T </span>
              {"\n"}
              <span className="qwerty-3"> 9</span>
              {"\n"}
              <span className="qwerty-8">Simple Interest:</span>
              <span className="qwerty-6">72</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>



        <h2 className='headings'>Q-Write a program to find and print area of rectangle in python?</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter value of </span>
              <span className="qwerty">L</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">l</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty">int</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter value of </span>
              <span className="qwerty">B</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">b</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty">int</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-7">area</span>
              <span className="qwerty-1">=</span>
              <span className="qwerty-4">l</span>
              <span className="qwerty">*</span>
              <span className="qwerty-4">b;</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-10">Area:</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty">,</span>
              <span className="qwerty-4">area</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>
        <h5 className='headings'> Output : </h5>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "100vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-10">Enter value of</span>
              <span className="qwerty-8"> L </span>
              {"\n"}
              <span className="qwerty-3"> 4</span>
              {"\n"}
              <span className="qwerty-10">Enter value of</span>
              <span className="qwerty-8"> B </span>
              {"\n"}
              <span className="qwerty-3"> 5</span>
              {"\n"}
              <span className="qwerty-8">Area:</span>
              <span className="qwerty-6">20</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>



        <h2 className='headings'>Q-Write a program to find out the value of the pi and print area of circle and user input in python?</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter value of </span>
              <span className="qwerty">R</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">r</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty">int</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-7">area</span>
              <span className="qwerty-1">=</span>
              <span className="qwerty-5">3.14</span>
              <span className="qwerty">*</span>
              <span className="qwerty-4">r</span>
              <span className="qwerty">*</span>
              <span className="qwerty-4">r;</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-9">"</span>
              <span className="qwerty-10">Area:</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty">,</span>
              <span className="qwerty-4">area</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>
        <h5 className='headings'> Output : </h5>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "100vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-1">Enter value of</span>
              <span className="qwerty-8"> R </span>
              {"\n"}
              <span className="qwerty-3"> 4</span>
              {"\n"}
              <span className="qwerty-8">Area:</span>
              <span className="qwerty-6">50.24</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>




        <h2 className='headings'>Q-Write a program to 3 subect marks, add all values and also multiply all the values input in python?</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter value of </span>
              <span className="qwerty">A</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">a</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty">int</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter value of </span>
              <span className="qwerty">B</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">b</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty">int</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter value of </span>
              <span className="qwerty">C</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-4">c</span>
              <span className="qwerty-9"> =</span>
              <span className="qwerty">int</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-6">(</span>
              <span className="qwerty-6">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-7">add</span>
              <span className="qwerty-1">=</span>
              <span className="qwerty-4">a</span>
              <span className="qwerty">+</span>
              <span className="qwerty-4">b</span>
              <span className="qwerty">+</span>
              <span className="qwerty-4">c;</span>
              {"\n"}
              <span className="qwerty-7">multiply</span>
              <span className="qwerty-1">=</span>
              <span className="qwerty-4">a</span>
              <span className="qwerty">*</span>
              <span className="qwerty-4">b</span>
              <span className="qwerty">*</span>
              <span className="qwerty-4">c;</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Add:</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty">,</span>
              <span className="qwerty-7">add</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Multiple:</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty">,</span>
              <span className="qwerty-7">multiply</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>
        <h5 className='headings'> Output : </h5>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "100vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-1">Enter value of</span>
              <span className="qwerty-8"> A </span>
              {"\n"}
              <span className="qwerty-3"> 2</span>
              {"\n"}
              <span className="qwerty-1">Enter value of</span>
              <span className="qwerty-8"> B </span>
              {"\n"}
              <span className="qwerty-3"> 4</span>
              {"\n"}
              <span className="qwerty-1">Enter value of</span>
              <span className="qwerty-8"> C </span>
              {"\n"}
              <span className="qwerty-3"> 6</span>
              {"\n"}
              <span className="qwerty-8">Add:</span>
              <span className="qwerty-6">12</span>
              {"\n"}
              <span className="qwerty-8">Multiple:</span>
              <span className="qwerty-6">48</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>

        <h3 className="mt-4 bold">Using for loop in Python input:</h3>



        <h2 className='headings'>Q-Write a program to input a no and sum by using for loop in python?</h2>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "500vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-4">sum</span>
              <span className="qwerty-1">=</span>
              <span className="qwerty-10">0</span>
              {"\n"}
              <span className="qwerty-5">for </span>
              <span className="qwerty-2">i</span>
              <span className="qwerty-7"> in</span>
              <span className="qwerty-6"> range</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-5">1</span>
              <span className="qwerty-1">,</span>
              <span className="qwerty-5">5</span>
              <span className="qwerty-1">)</span>
              <span className="qwerty-1">:</span>
              {"\n"}

              <span className="qwerty-4">    n</span>
              <span className="qwerty-9">=</span>
              <span className="qwerty">int</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-8">input</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Enter </span>
              <span className="qwerty-1">%</span>
              <span className="qwerty-4">i </span>

              <span className="qwerty-10">no</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-1">%i</span>
              <span className="qwerty-1">)</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-7">    sum</span>
              <span className="qwerty-1">=</span>
              <span className="qwerty-4">sum</span>
              <span className="qwerty">+</span>
              <span className="qwerty-7">n</span>
              {"\n"}
              <span className="qwerty-3">    print</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-1">"</span>
              <span className="qwerty-10">Sum=</span>
              <span className="qwerty-1">%</span>
              <span className="qwerty">d</span>
              <span className="qwerty-7">" </span>
              <span className="qwerty-10">%sum</span>
              <span className="qwerty-1">)</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>
        <h5 className='headings'> Output : </h5>
        <div style={{ background: "#0f0e33", width: "94%", marginLeft: "3%", paddingLeft: "2%", borderRadius: "20px" }} >
          <pre style={{ maxHeight: "100vh" }}>
            <code >
              {"\n"}
              <span className="qwerty-10">Enter</span>
              <span className="qwerty-8"> 1 </span>
              <span className="qwerty-10">no :</span>
              {"\n"}
              <span className="qwerty-3"> 5</span>
              {"\n"}
              <span className="qwerty-8">Sum:</span>
              <span className="qwerty-6">5</span>
              {"\n"}
              <span className="qwerty-10">Enter</span>
              <span className="qwerty-8"> 2 </span>
              <span className="qwerty-10">no:</span>
              {"\n"}
              <span className="qwerty-3"> 10</span>
              {"\n"}
              <span className="qwerty-8">Sum:</span>
              <span className="qwerty-6">15</span>
              {"\n"}
              <span className="qwerty-10">Enter</span>
              <span className="qwerty-8"> 3 </span>
              <span className="qwerty-10">no:</span>
              {"\n"}
              <span className="qwerty-3"> 15</span>
              {"\n"}
              <span className="qwerty-8">Sum:</span>
              <span className="qwerty-6">30</span>
              {"\n"}
              <span className="qwerty-10">Enter</span>
              <span className="qwerty-8"> 4 </span>
              <span className="qwerty-10">no:</span>
              {"\n"}
              <span className="qwerty-3"> 20</span>
              {"\n"}
              <span className="qwerty-8">Sum:</span>
              <span className="qwerty-6">50</span>
              {"\n"}
              {"\n"}
            </code>
          </pre>
        </div>


        <h1 className="mt-5"> </h1>

        <div className="back">
          <a href="/python-keywords">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a>
          <a href="/python-comments">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a>
        </div>
      </div>
    </div>
  )

}
export default Pinput;